import { useRecoilValue } from 'recoil'
import { useMemo } from 'react'
import maintenanceProcessesAtom from '../MaintenanceProcesses/maintenanceProcesses.atom.ts'
import { IMaintenanceProcess } from '../maintenance.types.ts'

const useMaintenanceProcess = (id: IMaintenanceProcess['id']) => {
  const processes = useRecoilValue(maintenanceProcessesAtom).items

  return useMemo(() => {
    return processes.find((s) => s.id === id)
  }, [id, processes])
}

export default useMaintenanceProcess
